import { render, staticRenderFns } from "./xxy-button.vue?vue&type=template&id=fa1c5416&scoped=true"
import script from "./xxy-button.vue?vue&type=script&lang=js"
export * from "./xxy-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1c5416",
  null
  
)

export default component.exports